import React from 'react';
import { useCalendar } from '../contexts/CalendarContext';
import DetachableCalendar from './DetachableCalendar';

/**
 * PersistentCalendar component that handles the detachable calendar
 * that persists across all pages of the application.
 */
const PersistentCalendar = () => {
  const { 
    isCalendarDetached, 
    closeCalendar, 
    handleDateChange 
  } = useCalendar();
  
  if (!isCalendarDetached) return null;
  
  return (
    <DetachableCalendar 
      onClose={closeCalendar}
      onDateChange={handleDateChange}
    />
  );
};

export default PersistentCalendar; 